import { FC } from 'react';

import { SvgIcon, SvgIconProps } from '@thirdspacelearning/library';

interface Props extends SvgIconProps {}

const BadgeProgrammeHalfway: FC<Props> = ({ ...props }) => (
    <SvgIcon
        width="81"
        height="81"
        viewBox="0 0 81 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="badge-claimed"
        {...props}
    >
        <rect
            x="3.11538"
            y="3.11538"
            width="74.7692"
            height="74.7692"
            rx="37.3846"
            fill="white"
        />
        <rect
            x="3.11538"
            y="3.11538"
            width="74.7692"
            height="74.7692"
            rx="37.3846"
            stroke="#F9DD4A"
            strokeWidth="6.23077"
            fill="white"
        />
        <g filter="url(#filter0_d_236_14142)">
            <path
                d="M22.0527 50.0833L22.0551 50.1126L22.0593 50.1417C22.1652 50.883 22.5312 51.9447 23.3046 52.841C24.1057 53.7694 25.3319 54.5002 27.0492 54.5002H36.801L38.6102 60.6515C39.0324 62.0872 41.066 62.0871 41.4882 60.6515L43.2974 54.5002H54.0492C55.3939 54.5002 57.5707 53.4206 58.0391 50.1417C58.4458 47.295 59.5488 32.2077 60.0468 25.0698L60.0492 25.0351V25.0002C60.0492 23.7016 59.7223 21.7563 58.7002 20.1001C57.6452 18.3905 55.8447 17.0002 53.0492 17.0002H26.5492C25.2998 17.0002 23.5193 17.4771 22.1167 18.8977C20.6843 20.3486 19.7673 22.6588 20.0527 26.0833L22.0527 50.0833Z"
                fill="#8CC687"
                stroke="white"
                strokeWidth="2"
            />
            <path
                d="M23.0491 50.0002L21.0491 26.0002C20.5831 20.4082 23.5701 18.4805 25.695 18.0831C26.0719 18.0126 26.319 18.4164 26.1598 18.7652C23.3422 24.9378 24.2067 38.1841 24.9353 45.2813C25.2142 47.998 27.5252 50.0002 30.2561 50.0002H56.4726C56.7768 50.0002 57.0124 50.2715 56.9435 50.5679C56.4018 52.8965 54.823 53.5002 54.0491 53.5002H42.9232C42.7014 53.5002 42.5061 53.6464 42.4435 53.8592L40.5288 60.3693C40.388 60.8479 39.7101 60.8479 39.5694 60.3693L37.6546 53.8592C37.5921 53.6464 37.3987 53.5002 37.1769 53.5002H27.0491C24.2491 53.5002 23.2157 51.1669 23.0491 50.0002Z"
                fill="#78B074"
            />
            <path
                d="M51.3324 28.7297L42.0724 24.0997C41.7769 23.9519 41.4292 24.1668 41.4292 24.4972V34.143C41.4292 34.4798 41.7892 34.6942 42.0853 34.5338L51.3453 29.518C51.6614 29.3467 51.654 28.8905 51.3324 28.7297Z"
                fill="#E56A6A"
                stroke="black"
                strokeWidth="1.5"
            />
            <path
                d="M40.985 22.0002H38.7628C38.5173 22.0002 38.3184 22.1992 38.3184 22.4447V46.0002C38.3184 46.2457 38.5173 46.4447 38.7628 46.4447H40.985C41.2305 46.4447 41.4295 46.2457 41.4295 46.0002V23.778V22.4447C41.4295 22.1992 41.2305 22.0002 40.985 22.0002Z"
                fill="#F9CB6E"
                stroke="black"
                strokeWidth="1.5"
            />
            <path
                d="M45.361 50.0003H34.7623C34.5169 50.0003 34.3152 49.8006 34.3493 49.5575C34.5244 48.3052 35.4457 46.8892 37.429 46.8892H42.3179C44.4513 46.8892 45.4309 48.4131 45.7605 49.5015C45.8389 49.7604 45.6314 50.0003 45.361 50.0003Z"
                fill="#E56A6A"
                stroke="black"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_236_14142"
                x="9.00098"
                y="10.0002"
                width="62.0483"
                height="66.728"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_236_14142"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_236_14142"
                    result="shape"
                />
            </filter>
        </defs>
    </SvgIcon>
);

export default BadgeProgrammeHalfway;
